"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var vue_3 = require("vue");
var message_input_editor_vue_1 = require("./message-input-editor.vue");
var message_input_at_vue_1 = require("./message-input-at.vue");
var message_input_button_vue_1 = require("./message-input-button.vue");
var message_input_reference_or_reply_vue_1 = require("./message-input-reference-or-reply.vue");
var utils_1 = require("../utils/utils");
var utils_2 = require("../../utils");
exports.default = vue_1.defineComponent({
    __name: 'index',
    props: {
        placeholder: {
            type: String,
            default: "this is placeholder",
        },
        conversation: {
            type: Object,
            default: function () { return ({}); },
        },
        replyOrReference: {
            type: Object,
            default: function () { return ({}); },
        },
        isGroup: {
            type: Boolean,
            default: false,
        },
        memberList: {
            type: Array,
            default: function () { return []; },
        },
        isMute: {
            type: Boolean,
            default: true,
        },
        muteText: {
            type: String,
            default: "",
        },
        enableInput: {
            type: Boolean,
            default: true,
        },
        enableAt: {
            type: Boolean,
            default: true,
        },
        enableDragUpload: {
            type: Boolean,
            default: true,
        },
        enableTyping: {
            type: Boolean,
            default: true,
        },
        env: {
            type: Object,
            default: function () { return ({}); },
        },
    },
    emits: ["sendMessage", "resetReplyOrReference", "onTyping"],
    setup: function (__props, _a) {
        var _this = this;
        var _b;
        var __expose = _a.expose, emit = _a.emit;
        var props = __props;
        var _c = vue_3.toRefs(props), placeholder = _c.placeholder, isGroup = _c.isGroup, memberList = _c.memberList, conversation = _c.conversation, replyOrReference = _c.replyOrReference, env = _c.env, enableTyping = _c.enableTyping;
        var editor = vue_3.ref();
        var isH5 = vue_3.ref((_b = props === null || props === void 0 ? void 0 : props.env) === null || _b === void 0 ? void 0 : _b.isH5);
        vue_3.watch(function () { return conversation.value; }, function (newVal, oldVal) {
            var _a;
            if ((newVal === null || newVal === void 0 ? void 0 : newVal.conversationID) !== (oldVal === null || oldVal === void 0 ? void 0 : oldVal.conversationID)) {
                // conversation change
                (_a = editor === null || editor === void 0 ? void 0 : editor.value) === null || _a === void 0 ? void 0 : _a.resetEditor();
            }
        }, {
            immediate: true,
        });
        var sendMessage = function () { return __awaiter(_this, void 0, void 0, function () {
            var TUIServer, messageList, replyOrReferenceObject;
            var _this = this;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        TUIServer = (_c = (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.TUIKitTUICore) === null || _b === void 0 ? void 0 : _b.TUIServer) === null || _c === void 0 ? void 0 : _c.TUIChat;
                        messageList = (_d = editor === null || editor === void 0 ? void 0 : editor.value) === null || _d === void 0 ? void 0 : _d.getEditorContent();
                        replyOrReferenceObject = replyOrReference.value;
                        return [4 /*yield*/, (messageList === null || messageList === void 0 ? void 0 : messageList.forEach(function (content) { return __awaiter(_this, void 0, void 0, function () {
                                var cloudCustomData, res, _a, error_1;
                                var _b, _c, _d, _e, _f, _g, _h, _j;
                                return __generator(this, function (_k) {
                                    switch (_k.label) {
                                        case 0:
                                            _k.trys.push([0, 16, , 17]);
                                            cloudCustomData = void 0, res = void 0;
                                            // handle message typing
                                            cloudCustomData = handleMessageWithTyping(cloudCustomData);
                                            _a = content === null || content === void 0 ? void 0 : content.type;
                                            switch (_a) {
                                                case "text": return [3 /*break*/, 1];
                                                case "image": return [3 /*break*/, 8];
                                                case "video": return [3 /*break*/, 10];
                                                case "file": return [3 /*break*/, 12];
                                            }
                                            return [3 /*break*/, 14];
                                        case 1:
                                            // 引用和回复只支持文本消息（对标微信）
                                            // replay or reference message
                                            cloudCustomData = handleMessageReplyOrReference(cloudCustomData);
                                            if (!((_b = content === null || content === void 0 ? void 0 : content.payload) === null || _b === void 0 ? void 0 : _b.atUserList)) return [3 /*break*/, 3];
                                            return [4 /*yield*/, (TUIServer === null || TUIServer === void 0 ? void 0 : TUIServer.sendTextAtMessage({
                                                    text: JSON.parse(JSON.stringify((_c = content === null || content === void 0 ? void 0 : content.payload) === null || _c === void 0 ? void 0 : _c.text)),
                                                    atUserList: (_d = content === null || content === void 0 ? void 0 : content.payload) === null || _d === void 0 ? void 0 : _d.atUserList,
                                                }, cloudCustomData))];
                                        case 2:
                                            res = _k.sent();
                                            return [3 /*break*/, 5];
                                        case 3: return [4 /*yield*/, (TUIServer === null || TUIServer === void 0 ? void 0 : TUIServer.sendTextMessage(JSON.parse(JSON.stringify((_e = content === null || content === void 0 ? void 0 : content.payload) === null || _e === void 0 ? void 0 : _e.text)), cloudCustomData))];
                                        case 4:
                                            res = _k.sent();
                                            _k.label = 5;
                                        case 5:
                                            if (!((replyOrReferenceObject === null || replyOrReferenceObject === void 0 ? void 0 : replyOrReferenceObject.show) === "reply")) return [3 /*break*/, 7];
                                            return [4 /*yield*/, TUIServer.replyMessage((_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.message)];
                                        case 6:
                                            _k.sent();
                                            _k.label = 7;
                                        case 7: return [3 /*break*/, 15];
                                        case 8: return [4 /*yield*/, (TUIServer === null || TUIServer === void 0 ? void 0 : TUIServer.sendImageMessage((_g = content === null || content === void 0 ? void 0 : content.payload) === null || _g === void 0 ? void 0 : _g.file))];
                                        case 9:
                                            _k.sent();
                                            return [3 /*break*/, 15];
                                        case 10: return [4 /*yield*/, (TUIServer === null || TUIServer === void 0 ? void 0 : TUIServer.sendVideoMessage((_h = content === null || content === void 0 ? void 0 : content.payload) === null || _h === void 0 ? void 0 : _h.file))];
                                        case 11:
                                            _k.sent();
                                            return [3 /*break*/, 15];
                                        case 12: return [4 /*yield*/, (TUIServer === null || TUIServer === void 0 ? void 0 : TUIServer.sendFileMessage((_j = content === null || content === void 0 ? void 0 : content.payload) === null || _j === void 0 ? void 0 : _j.file))];
                                        case 13:
                                            _k.sent();
                                            return [3 /*break*/, 15];
                                        case 14: return [3 /*break*/, 15];
                                        case 15:
                                            emit("sendMessage");
                                            return [3 /*break*/, 17];
                                        case 16:
                                            error_1 = _k.sent();
                                            utils_2.handleErrorPrompts(error_1, env.value);
                                            return [3 /*break*/, 17];
                                        case 17: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _f.sent();
                        (_e = editor === null || editor === void 0 ? void 0 : editor.value) === null || _e === void 0 ? void 0 : _e.resetEditor();
                        resetReplyOrReference();
                        return [2 /*return*/];
                }
            });
        }); };
        var onTyping = function (inputContentEmpty, inputBlur) {
            emit("onTyping", inputContentEmpty, inputBlur);
        };
        var handleMessageWithTyping = function (cloudCustomData) {
            if (enableTyping.value) {
                if (!cloudCustomData) {
                    cloudCustomData = {};
                }
                cloudCustomData.messageFeature = {
                    needTyping: 1,
                    version: 1,
                };
            }
            return cloudCustomData;
        };
        var handleMessageReplyOrReference = function (cloudCustomData) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
            if (((_a = replyOrReference === null || replyOrReference === void 0 ? void 0 : replyOrReference.value) === null || _a === void 0 ? void 0 : _a.show) !== "reply" && ((_b = replyOrReference === null || replyOrReference === void 0 ? void 0 : replyOrReference.value) === null || _b === void 0 ? void 0 : _b.show) !== "reference") {
                return cloudCustomData;
            }
            if (!cloudCustomData) {
                cloudCustomData = {};
            }
            console.log("messageAbstract", replyOrReference === null || replyOrReference === void 0 ? void 0 : replyOrReference.value);
            cloudCustomData.messageReply = {
                messageAbstract: (_c = replyOrReference === null || replyOrReference === void 0 ? void 0 : replyOrReference.value) === null || _c === void 0 ? void 0 : _c.content,
                messageSender: ((_e = (_d = replyOrReference === null || replyOrReference === void 0 ? void 0 : replyOrReference.value) === null || _d === void 0 ? void 0 : _d.message) === null || _e === void 0 ? void 0 : _e.nick) || ((_g = (_f = replyOrReference === null || replyOrReference === void 0 ? void 0 : replyOrReference.value) === null || _f === void 0 ? void 0 : _f.message) === null || _g === void 0 ? void 0 : _g.from),
                messageID: (_j = (_h = replyOrReference === null || replyOrReference === void 0 ? void 0 : replyOrReference.value) === null || _h === void 0 ? void 0 : _h.message) === null || _j === void 0 ? void 0 : _j.ID,
                messageType: (_k = replyOrReference === null || replyOrReference === void 0 ? void 0 : replyOrReference.value) === null || _k === void 0 ? void 0 : _k.type,
                version: 1,
            };
            if (((_l = replyOrReference === null || replyOrReference === void 0 ? void 0 : replyOrReference.value) === null || _l === void 0 ? void 0 : _l.show) === "reply") {
                try {
                    cloudCustomData.messageReply.messageRootID = (_o = (_m = replyOrReference === null || replyOrReference === void 0 ? void 0 : replyOrReference.value) === null || _m === void 0 ? void 0 : _m.message) === null || _o === void 0 ? void 0 : _o.ID;
                    if ((_q = (_p = replyOrReference === null || replyOrReference === void 0 ? void 0 : replyOrReference.value) === null || _p === void 0 ? void 0 : _p.message) === null || _q === void 0 ? void 0 : _q.cloudCustomData) {
                        var replyMessageCloudCustomData = utils_1.JSONToObject((_s = (_r = replyOrReference === null || replyOrReference === void 0 ? void 0 : replyOrReference.value) === null || _r === void 0 ? void 0 : _r.message) === null || _s === void 0 ? void 0 : _s.cloudCustomData);
                        cloudCustomData.messageReply.messageRootID =
                            ((_t = replyMessageCloudCustomData === null || replyMessageCloudCustomData === void 0 ? void 0 : replyMessageCloudCustomData.messageReply) === null || _t === void 0 ? void 0 : _t.messageRootID) || ((_v = (_u = replyOrReference === null || replyOrReference === void 0 ? void 0 : replyOrReference.value) === null || _u === void 0 ? void 0 : _u.message) === null || _v === void 0 ? void 0 : _v.ID);
                    }
                }
                catch (error) {
                    console.warn(error);
                }
            }
            return cloudCustomData;
        };
        var addEmoji = function (emoji) {
            var _a;
            (_a = editor === null || editor === void 0 ? void 0 : editor.value) === null || _a === void 0 ? void 0 : _a.addEmoji(emoji);
        };
        var resetReplyOrReference = function () {
            emit("resetReplyOrReference");
        };
        var reEdit = function (content) {
            var _a, _b;
            (_a = editor === null || editor === void 0 ? void 0 : editor.value) === null || _a === void 0 ? void 0 : _a.resetEditor();
            resetReplyOrReference();
            (_b = editor === null || editor === void 0 ? void 0 : editor.value) === null || _b === void 0 ? void 0 : _b.setEditorContent(content);
        };
        __expose({
            addEmoji: addEmoji,
            reEdit: reEdit,
        });
        return function (_ctx, _cache) {
            var _a, _b;
            return (vue_2.openBlock(), vue_2.createElementBlock("div", {
                class: vue_2.normalizeClass(['message-input', isH5.value && 'message-input-h5'])
            }, [
                vue_2.createVNode(message_input_editor_vue_1.default, {
                    ref_key: "editor",
                    ref: editor,
                    isH5: isH5.value,
                    placeholder: vue_2.unref(placeholder),
                    isGroup: vue_2.unref(isGroup),
                    isMute: __props.isMute,
                    muteText: __props.muteText,
                    enableInput: __props.enableInput,
                    enableAt: __props.enableAt,
                    enableTyping: vue_2.unref(enableTyping),
                    enableDragUpload: __props.enableDragUpload,
                    onSendMessage: sendMessage,
                    onOnTyping: onTyping
                }, null, 8, ["isH5", "placeholder", "isGroup", "isMute", "muteText", "enableInput", "enableAt", "enableTyping", "enableDragUpload"]),
                (!__props.isMute)
                    ? (vue_2.openBlock(), vue_2.createBlock(message_input_button_vue_1.default, {
                        key: 0,
                        isH5: isH5.value,
                        onSendMessage: sendMessage
                    }, null, 8, ["isH5"]))
                    : vue_2.createCommentVNode("", true),
                (__props.enableAt)
                    ? (vue_2.openBlock(), vue_2.createBlock(message_input_at_vue_1.default, {
                        key: 1,
                        memberList: vue_2.unref(memberList),
                        isGroup: vue_2.unref(isGroup),
                        selfInfo: (_b = (_a = vue_2.unref(conversation)) === null || _a === void 0 ? void 0 : _a.groupProfile) === null || _b === void 0 ? void 0 : _b.selfInfo,
                        isH5: isH5.value
                    }, null, 8, ["memberList", "isGroup", "selfInfo", "isH5"]))
                    : vue_2.createCommentVNode("", true),
                vue_2.createVNode(message_input_reference_or_reply_vue_1.default, {
                    replyOrReference: vue_2.unref(replyOrReference),
                    isH5: isH5.value,
                    onResetReplyOrReference: resetReplyOrReference
                }, null, 8, ["replyOrReference", "isH5"])
            ], 2));
        };
    }
});
